import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "p-0 mt-0 mb-4 text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Account Security Upgrade"),
  /*#__PURE__*/_createTextVNode(" ADHE is implementing additional security measures to protect user accounts. You must provide answers to three security questions of your choice before logging in for the first time. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white mt-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-user-lock" }),
  /*#__PURE__*/_createTextVNode(" Security Questions")
], -1)
const _hoisted_4 = { class: "card mb-2" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "question-1",
  class: "mb-2"
}, "Question #1", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "question-2",
  class: "mb-2"
}, "Question #2", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-12 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "question-3",
  class: "mb-2"
}, "Question #3", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "alert alert-danger text-center p-2 rounded-2 text-danger" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Update Security Information")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Proceed to login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_button = _resolveComponent("activity-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", null, [
      _createElementVNode("section", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  id: "question-1",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.selectedSecurityQuestions[0].securityQuestionId = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionSubset(0), (q) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: q.id,
                      value: q.id
                    }, _toDisplayString(q.prompt), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.selectedSecurityQuestions[0].securityQuestionId]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control mt-1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.selectedSecurityQuestions[0].answer = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.selectedSecurityQuestions[0].answer]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("select", {
                  id: "question-2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.selectedSecurityQuestions[1].securityQuestionId = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionSubset(1), (q) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: q.id,
                      value: q.id
                    }, _toDisplayString(q.prompt), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.selectedSecurityQuestions[1].securityQuestionId]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control mt-1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.selectedSecurityQuestions[1].answer = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.selectedSecurityQuestions[1].answer]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  id: "question-3",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.selectedSecurityQuestions[2].securityQuestionId = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionSubset(2), (q) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: q.id,
                      value: q.id
                    }, _toDisplayString(q.prompt), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.selectedSecurityQuestions[2].securityQuestionId]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control mt-1",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.selectedSecurityQuestions[2].answer = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.selectedSecurityQuestions[2].answer]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_16, " Each Security Question answer must be at least 3 characters. ", 512), [
            [_vShow, !_ctx.isValid()]
          ])
        ]),
        (!_ctx.state.questionsUpdated)
          ? (_openBlock(), _createBlock(_component_activity_button, {
              key: 0,
              class: "btn btn-warning w-100",
              disabled: !_ctx.isValid(),
              "click-handler": _ctx.updateSecurityQuestions
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["disabled", "click-handler"]))
          : _createCommentVNode("", true),
        (_ctx.state.questionsUpdated)
          ? (_openBlock(), _createBlock(_component_activity_button, {
              key: 1,
              class: "btn btn-primary w-100",
              "click-handler": _ctx.proceedToLogin,
              "continue-loading-on-success": true
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["click-handler"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}